import { createStyles, Modal } from '@mantine/core';
import { Text } from '@repo/foundations';
import { typography } from '@repo/theme/primitives';
import { observer } from 'mobx-react-lite';
import PropagateMetadata from './PropagateMetadata';
import { propagateMetadataModalStore } from './store';

const useStyles = createStyles((theme) => ({
	body: {
		paddingLeft: theme.spacing.md,
		paddingRight: theme.spacing.md,
		paddingTop: theme.spacing.lg,
	},
	close: { transform: 'scale(1.25)' },
	header: {
		paddingLeft: theme.spacing.md,
		paddingRight: theme.spacing.md,
		paddingTop: theme.spacing.xs,
		paddingBottom: theme.spacing.xs,
		borderBottom: `thin solid ${theme.other.getColor('fill/secondary/default')}`,
	},
	title: {
		fontSize: theme.fontSizes.md,
		fontWeight: typography.weight.bold,
	},
}));

function PropagateMetadataModal() {
	const { classes } = useStyles();

	return (
		<Modal
			classNames={{
				body: classes.body,
				close: classes.close,
				header: classes.header,
			}}
			size="60%"
			padding={0}
			opened={propagateMetadataModalStore.isOpen}
			onClose={propagateMetadataModalStore.closeModal}
			title={
				<Text size="md" fw={600}>
					Propagate
				</Text>
			}
			withinPortal
		>
			{propagateMetadataModalStore.entityId && (
				<PropagateMetadata
					entityId={propagateMetadataModalStore.entityId}
					isModal
				/>
			)}
		</Modal>
	);
}

const PropagateMetadataModalObserver = observer(PropagateMetadataModal);
export default PropagateMetadataModalObserver;
